import React, { memo, useCallback, useState } from "react";
import SearchTextField from "./SearchTextField";

interface MemoizedSearchInputProps {
  initialValue: string;
  onSubmit: (value: string) => void;
  onClear: () => void;
}

const MemoizedSearchInput: React.FC<MemoizedSearchInputProps> = memo(
  ({ initialValue, onSubmit, onClear }) => {
    const [localValue, setLocalValue] = useState(initialValue);

    // Update local value when initial value changes (e.g., from URL)
    React.useEffect(() => {
      setLocalValue(initialValue);
    }, [initialValue]);

    const handleChange = useCallback((value: string) => {
      setLocalValue(value);
    }, []);

    const handleKeyPress = useCallback(
      (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
          onSubmit(localValue);
        }
      },
      [localValue, onSubmit]
    );

    const handleClear = useCallback(() => {
      setLocalValue("");
      onClear();
    }, [onClear]);

    return (
      <SearchTextField
        value={localValue}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        onClear={handleClear}
      />
    );
  }
);

MemoizedSearchInput.displayName = "MemoizedSearchInput";

export default MemoizedSearchInput;
